export const iconFontAwesomeHolidaysSleigh = (
	<i className="fa-solid fa-sleigh"></i>
);
